<script>
import resources from './resources'
import SlideUpDown from 'vue-slide-up-down'

export default {
  name: 'professional-items',
  mixins: [resources],
  components: {
    SlideUpDown
  }
}
</script>

<template lang="pug">
  .item.text-left
    .row
      .col-xs-12.col-sm-4.col-md-2
        div
          //- Removendo para  adcionar somente a foto do company
          .avatars-company.hidden-xs(v-if="item.is_company")
            span.avatar-company
              img(:src="item.avatar", width='100%', style="border-radius:50%; box-shadow: 0 0 0 1px #babeca;")
            //-span.avatar-company-professional
              img.avatar-professional(:src="item.avatar", width='50%', style="z-index: 8;")
          .avatars.hidden-sm.hidden-md.hidden-lg(v-if="item.is_company")
            span.avatar
              img(:src="item.avatar_company", width='100%', style="border-radius:50%; box-shadow: 0 0 0 1px #babeca;")

          .avatars(v-if="!item.is_company")
            span.avatar
              img(:src="item.avatar", width='100%', style="border-radius:50%; box-shadow: 0 0 0 1px #babeca;")

      .col-xs-12.col-sm-8.col-md-10
        .row
            .col-xs-12.col-sm-12.col-md-6
                company_information(
                  :name="item.company_slug",
                  :document="item.document",
                  :professionalState="item.professional_state",
                  :speciality="item.speciality",
                  :companySlug="item.company_slug",
                  :companyType="item.company_type",
                  :professionalName="item.professional",
                  :street="item.street",
                  :number="item.number",
                  :complement="item.complement"
                  :zip="item.zip",
                  :district="item.district",
                  :city="item.city",
                  :countryState="item.state",
                  :isCompany="item.is_company",
                  v-if="item.is_company"
                )

                personal-information(
                  :name="item.professional.name",
                  :document="item.document",
                  :professionalState="item.professional_state",
                  :speciality="item.speciality",
                  :companySlug="item.company_slug",
                  :companyType="item.company_type",
                  :professionalName="item.professional_name",
                  :street="item.street",
                  :number="item.number",
                  :complement="item.complement"
                  :zip="item.zip",
                  :district="item.district",
                  :city="item.city",
                  :countryState="item.state",
                  v-if="!item.is_company"
                )
            .col-xs-12.col-sm-12.col-md-5(style="margin-top: 40px; margin-right: 0px;")
              schedule(:agenda="item")

            .row.border-top(v-if="item.agenda_info")
              .col-xs-12.col-sm-10.col-md-10
                small.speciality.small-complementary-information Informações Complementares
                p.complementary-information
                  strong {{ item.agenda_info }}
      .row.agenda-covenants
        .col-xs-12.col-sm-12.col-md-12
            strong.small-complementary-information Convênios
            .planos(v-if="item.covenant && operatorCovenant")
              span(v-for="covenants in item.covenant_slug.split(',')" :tag="covenants", v-if="covenants.trim()  === operatorCovenant")
                strong(style="color: #1384d8") {{ covenants }}

            .planos(v-if="item.covenant && !operatorCovenant")
              span(v-for="covenants in item.covenant_slug.split(',')" :tag="covenants")
                strong(style="color: #1384d8") {{ covenants }}

      .row.m-top-25
        .col-xs-12.col-sm-12.col-md-10.col-md-offset-1(v-if="item.latitude && item.longitude")
            .col-md-3.col-sm-4(style="color: #878787;")
              .button.see-more-map.pull-right.no-undeline.mb-cursor-pointer.text-center.hidden-lg.hidden-md.hidden-sm(:data-id="item.id", v-on:click="isShow = !isShow")
                span.icon 
                | Ver Mapa

              .ver-mapa.curso-pointer.hidden-xs(:data-id="item.id", v-on:click="isShow = !isShow")
                span.icon 
                | Ver Mapa

            .col-md-3.col-sm-4(style="color: #878787;")
              .button.see-more-curriculo.pull-right.no-undeline.mb-cursor-pointer.text-center.hidden-lg.hidden-md.hidden-sm(v-on:click="isShowProfile = !isShowProfile")
                  span.icon 
                  | Curriculo

              .ver-mapa.curso-pointer.hidden-xs(v-on:click="isShowProfile = !isShowProfile")
                  span.icon 
                  | Curriculo

            .col-md-5.col-sm-4(style="color: #878787;")
              .button.see-more-private.pull-right.no-undeline.mb-cursor-pointer.text-center.hidden-lg.hidden-md.hidden-sm(:data-id="item.id", @click.prevent="isShowPrice = !isShowPrice")
                span.icon 
                | Consulta Particular

              .ver-mapa.curso-pointer.hidden-xs(:data-id="item.id", @click.prevent="isShowPrice = !isShowPrice")
                span.icon 
                | Consulta Particular
        .row.col-xs-12.col-sm-12.col-md-12.mag.m-left-25
            slide-up-down(:active='isShowPrice', :duration="1000", style=" margin-top: 20px;")
              .h5-title
                h5(style="color: #666666")
                  strong Preço Particular
              small
                strong(style="color: #1384d8;") Para conferir os valores particulares, realize seu login.
        .row.col-xs-12.col-sm-12.col-md-12.mag.m-left-25
            slide-up-down(:active='isShow', :duration="1000", :key="item.agenda_id")
              .h5-title
                h5(style="color: #666666")
                  strong Localização
                maps(:latitude='item.latitude', :longitude='item.longitude')
            br
        .row.col-xs-10.col-sm-12.col-md-12.m-left-25
            slide-up-down(:active='isShowProfile', :duration="800", :key="item.agenda_id", :data-id="item.agenda_id")
                .h5-title(style="color: #666666")
                  h5
                    strong Formação Profissional
                small(v-if="item.company_professional.specializations.length <= 0 && item.company_professional.specializations.length <= 0")
                  strong  Este profissional ainda não publicou nenhuma informação em seu perfil.
                specializations(:specialization="specialization", v-for="specialization in item.company_professional.specializations", :key="specialization.id", v-if="item.company_professional.specializations.length > 0")
                graduations(:graduation='graduation',  v-for='graduation in item.company_professional.graduations', :key="graduation.id", v-if="item.company_professional.graduations.length > 0")
</template>
<style scoped>
.m-top-25 {
     margin-top: 25px;
}
 #results .item .icon {
     margin-bottom: 10px;
     position: relative;
}
 #results .item .icon:after {
     content: "";
     position: absolute;
     width: 45px;
     height: 2px;
     background: #1384d8;
     left: 50%;
     margin-left: 13px;
     bottom: -7px;
}
 span.icon {
     font-family: 'agenda-font-icons';
     margin: 0px 5px;
}
 .m-left-25 {
     margin-left: 25px;
}
 .agenda-covenants {
     margin: -10px 0px -15px 0px;
     font-size: 85%;
}
 .curso-pointer {
     cursor: pointer;
}
 .item h4 {
     padding: 0px 10px;
}
 #apresentacao .item {
     width: 100%;
     margin: 0px 0%;
     padding: 0px 0px;
     background: #ffffff;
     border-radius: 10px;
     text-align: center;
     color: #878787;
     min-height: 260px;
     cursor: default;
     -webkit-transition: box-shadow ease .3s;
     -webkit-transition: -webkit-box-shadow ease .3s;
     transition: -webkit-box-shadow ease .3s;
     transition: box-shadow ease .3s;
     transition: box-shadow ease .3s, -webkit-box-shadow ease .3s;
}
 #apresentacao .item .icon:after {
     content: "";
     position: absolute;
     width: 45px;
     height: 2px;
     background: #1384d8;
     left: 50%;
     margin-left: 13px;
     bottom: -7px;
}
 .consulta-particular {
     color: #898989;
     margin-top: 10px;
}
 .planos {
     margin-top: 10px;
}
 .planos span {
     display: inline-block;
     margin: 3px 2px;
     padding: 2px 15px;
     border: 1px solid #1384d8;
     color: #1384d8;
     border-radius: 50px;
     cursor: default;
}
 .complementary-information {
     font-size: 10px;
     font-weight: bold;
     color: #898989;
     text-align: justify;
}
 .small-complementary-information {
     color: #387ab9;
     font-size: 1.1em;
     font-weight: bold;
}
 .avatar img {
     border-radius: 50%;
     position: relative;
     left: -5px;
     margin-left: -30px;
     z-index: 1;
}
 .avatar-company-professional img {
     border-radius: 50%;
     position: relative;
     margin-top: -60px;
     margin-left: 40px;
     z-index: 1;
}
 .avatar-company img {
     border-radius: 50%;
     position: relative;
     margin-left: 0px;
     left: 10px;
     z-index: 1;
}
 .avatars {
     direction: rtl;
     text-align: left;
     padding-left: 70px;
}
 .avatars-company {
     direction: rtl;
     text-align: left;
     padding-left: 0px;
     margin-top: 50px;
}
 .avatar-professional {
     z-index: 8;
     margin-top: 72px;
     margin-left: -58px;
     border-radius:50%;
     -webkit-box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
     -moz-box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
     box-shadow:2px 2px 11px 0px rgba(50, 50, 25, 1);
}
/* IPad */
 @media (max-width:768px) {
     .m-left-25 {
         margin-left: 17px;
    }
     #results .item .icon {
         margin-bottom: 10px;
         position: relative;
    }
     #results .item .icon:after {
         content: "";
         position: absolute;
         width: 45px;
         height: 2px;
         background: #1384d8;
         left: 50%;
         margin-left: 13px;
         bottom: -7px;
    }
     span.icon {
         font-family: 'agenda-font-icons';
         margin: 0px 5px;
    }
     .avatar-company img {
         border-radius: 50%;
         position: relative;
         margin-left: -10px;
         z-index: 1;
    }
     .consulta-particular {
         color: #898989;
         margin-top: 10px;
    }
     .avatars {
         direction: rtl;
         text-align: left;
         padding-left: 70px;
    }
     .avatars-company {
         direction: rtl;
         text-align: left;
         padding-left: 30px;
    }
}
/* Outros navegadores */
 @media (max-width:992px) {
}
/* iphones 6/7/8/Plus */
 @media (max-width:767px) {
     #results .item .icon:after {
         content: "";
         position: absolute;
         width: 45px;
         height: 2px;
         left: 50%;
         margin-left: 13px;
         bottom: -7px;
    }
     .avatar-company img {
         border-radius: 50%;
         position: relative;
         left: -5px;
         margin-left: -30px;
         z-index: 1;
         margin-top: -100px;
    }
     .avatar-professional {
         margin-top: 0px;
    }
     #apresentacao .item {
         width: 100%;
         margin: 0px 0%;
         padding: 0px 0px;
         background: #ffffff;
         border-radius: 10px;
         text-align: left;
         color: #878787;
         min-height: 260px;
         cursor: default;
         -webkit-transition: box-shadow ease .3s;
         -webkit-transition: -webkit-box-shadow ease .3s;
         transition: -webkit-box-shadow ease .3s;
         transition: box-shadow ease .3s;
         transition: box-shadow ease .3s, -webkit-box-shadow ease .3s;
    }
     #apresentacao .item .icon:after {
         content: "";
         position: absolute;
         width: 45px;
         height: 2px;
         background: #1384d8;
         left: 50%;
         margin-left: 13px;
         bottom: -7px;
    }
     .small-complementary-information {
         color: #333;
         font-size: 1.3em;
         font-weight: bold;
         margin-top: 25px;
    }
     #apresentacao .item .icon {
         margin-bottom: 30px;
         position: relative;
    }
     .m-left-25 {
         margin-left: 8px;
    }
     .see-more-map {
         width: 100%;
         background: #0c6bb5;
         color: #FFFFFF;
         border-radius: 50px;
         padding: 6px 20px;
         border: none;
         margin-top: 10px;
         -webkit-transition: background ease .3s, padding ease .3s;
         transition: background ease .3s, padding ease .3s;
    }
     .see-more-curriculo {
         width: 100%;
         background: #0c6bb5;
         color: #FFFFFF;
         border-radius: 50px;
         padding: 6px 20px;
         border: none;
         margin-top: 10px;
         -webkit-transition: background ease .3s, padding ease .3s;
         transition: background ease .3s, padding ease .3s;
    }
     .see-more-private {
         width: 100%;
         background: #0c6bb5;
         color: #FFFFFF;
         border-radius: 50px;
         padding: 6px 20px;
         border: none;
         margin-top: 10px;
         -webkit-transition: background ease .3s, padding ease .3s;
         transition: background ease .3s, padding ease .3s;
    }
     .avatar img {
         border-radius: 50%;
         position: relative;
         left: -5px;
         margin-left: -30px;
         z-index: 1;
         margin-top: 20px;
    }
     .agenda-covenants {
         margin: -10px 0px -15px 0px;
         font-size: 9px;
        ;
    }
     #results .item .icon {
         margin-bottom: 10px;
         position: relative;
    }
}
</style>



// WEBPACK FOOTER //
// src/app/patient/profile-company/components/Items/items.vue